export default {
  smallTextUpperLeft: 'Work with us',
  titleUpperLeft: 'Tell us about your project',
  titleUpperLeftBottom: 'New Business',
  textUpperLeftBottom: '+46 (0)70- 990 79 26',
  smallTextLowerLeft: 'Contact',
  titleLowerLeftTop: 'We\'d love to hear from you',
  titleLowerLeftBottom: 'General inquiries',
  smallTextLowerLeftBottom: '+46 (0)70- 990 79 26',
  smallTextUpperRight: 'Office',
  titleUpperRight: '',
  smallTextLowerRight: 'Career',
  titleLowerRightTop: 'We\'re looking for new talent',
  titleLowerRightBottom: 'Are you the next member of our awesome team?',
};
